module.exports = __webpack_public_path__ + "img/ST0047.0ad9134.jpg";